import { useEffect, useRef, useState } from "react";
import { Button } from "../ui/button";

// Zone de signature au doigt ou a la souris. Renvoie une image PNG (data URL)
// via onChange, ou "" quand la zone est effacee.
export default function SignaturePad({ onChange }) {
  const ref = useRef(null);
  const dessin = useRef(false);
  const [vide, setVide] = useState(true);

  useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#111";
  }, []);

  const point = (e) => {
    const r = ref.current.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };

  const debut = (e) => {
    e.preventDefault();
    ref.current.setPointerCapture?.(e.pointerId);
    dessin.current = true;
    const ctx = ref.current.getContext("2d");
    const p = point(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
  };

  const trace = (e) => {
    if (!dessin.current) return;
    e.preventDefault();
    const ctx = ref.current.getContext("2d");
    const p = point(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
  };

  const fin = () => {
    if (!dessin.current) return;
    dessin.current = false;
    setVide(false);
    onChange?.(ref.current.toDataURL("image/png"));
  };

  const effacer = () => {
    const c = ref.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setVide(true);
    onChange?.("");
  };

  return (
    <div className="space-y-2">
      <canvas
        ref={ref}
        className="w-full h-40 border-2 border-dashed rounded-md bg-white touch-none"
        onPointerDown={debut}
        onPointerMove={trace}
        onPointerUp={fin}
        onPointerLeave={fin}
        data-testid="zone-signature"
      />
      <div className="flex items-center justify-between">
        <span className="text-xs text-muted-foreground">
          {vide ? "Signez dans le cadre avec le doigt ou la souris." : "Signature tracée."}
        </span>
        <Button type="button" size="sm" variant="outline" onClick={effacer}>Effacer</Button>
      </div>
    </div>
  );
}
